import { FC, ReactElement } from "react"
import { Link } from "react-router-dom"
import clsx from "clsx"

import { TableDataType } from "constants/eums"
import { TableColumnsInterface } from "constants/interfaces"

import { formatDateTime, formatTableCell } from "util/formatter"

type Props = {
  column: TableColumnsInterface
  rawValue: any
  row?: any
  className?: string
}

export const AccordionTableCell: FC<Props> = ({ column, rawValue, row, className }): ReactElement => {
  return (
    <td className={clsx("py-3 px-3 text-sm break-all", className)}>
      {column.customRender ? (
        <div>{column.customRender(rawValue, row)}</div>
      ) : column.format === TableDataType.IMAGE && rawValue ? (
        <img className="h-10 w-auto max-w-full" src={rawValue} alt="Image icon" />
      ) : column.format === TableDataType.FILE ? (
        <div>{rawValue}</div>
      ) : column.format === TableDataType.DATE ? (
        <div className="tooltip" data-tip={formatDateTime(rawValue)}>
          {formatTableCell(rawValue, column.format)}
        </div>
      ) : column.link ? (
        <Link to={column.link(rawValue)} className="underline">
          {formatTableCell(rawValue, column.format)}
        </Link>
      ) : (
        formatTableCell(rawValue, column.format)
      )}
    </td>
  )
}
